import { compose } from 'ramda';
import { redirect } from 'redux-first-router';

import { toEmailLogin } from '../../../../store/location/actions';
import { selectTheme } from '../../../../store/theme/selectors';
import { logoutAndClearClientState } from '../../../auth';
import { requireAuthentication } from '../../guards';

export const path = '/logout';

export const component = 'Loading';

export const thunk =
  ({ ctx, graphqlClient }) =>
  async (dispatch, getState) => {
    if (requireAuthentication(dispatch, getState)) return;

    const state = getState();
    const product = selectTheme(state);

    await logoutAndClearClientState({ ctx, dispatch, graphqlClient });

    compose(dispatch, redirect, toEmailLogin)({ query: { product } });
  };
